import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
  public email: string = '';
  public loading: boolean = false;
  public emailSent: boolean = false;
  private apiServerUrl: string = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  public onSubmit(): void {
    if (!this.email || !this.email.trim()) {
      return;
    }

    this.loading = true;

    this.http
      .post(`${this.apiServerUrl}/auth/forgot-password`, { email: this.email })
      .subscribe({
        next: () => {
          this.emailSent = true;
          this.loading = false;
        },
        error: () => {
          // Backend uvijek vraća 200, ali za svaki slučaj pokazujemo success
          this.emailSent = true;
          this.loading = false;
        },
      });
  }
}
